// Move IDs and names/types as defined in the ROM (EmeraldBlitz src/data/moves_info.h
// + include/constants/moves.h). Index = ROM move ID (gMovesInfo) = sav/RAM value.
// Note: the DB migration (backend/migrations/20260220000000_add_moves_table.sql)
// is missing two moves that exist in the ROM: 165 Struggle and 932 G-Max Depletion.

export const MOVES: Record<number, { name: string; type: string }> = {
  1: { name: "Pound", type: "NORMAL" },
  2: { name: "Karate Chop", type: "FIGHTING" },
  3: { name: "Double Slap", type: "NORMAL" },
  4: { name: "Comet Punch", type: "NORMAL" },
  5: { name: "Mega Punch", type: "NORMAL" },
  6: { name: "Pay Day", type: "NORMAL" },
  7: { name: "Fire Punch", type: "FIRE" },
  8: { name: "Ice Punch", type: "ICE" },
  9: { name: "Thunder Punch", type: "ELECTRIC" },
  10: { name: "Scratch", type: "NORMAL" },
  11: { name: "Vise Grip", type: "NORMAL" },
  12: { name: "Guillotine", type: "NORMAL" },
  13: { name: "Razor Wind", type: "NORMAL" },
  14: { name: "Swords Dance", type: "NORMAL" },
  15: { name: "Cut", type: "NORMAL" },
  16: { name: "Gust", type: "FLYING" },
  17: { name: "Wing Attack", type: "FLYING" },
  18: { name: "Whirlwind", type: "NORMAL" },
  19: { name: "Fly", type: "FLYING" },
  20: { name: "Bind", type: "NORMAL" },
  21: { name: "Slam", type: "NORMAL" },
  22: { name: "Vine Whip", type: "GRASS" },
  23: { name: "Stomp", type: "NORMAL" },
  24: { name: "Double Kick", type: "FIGHTING" },
  25: { name: "Mega Kick", type: "NORMAL" },
  26: { name: "Jump Kick", type: "FIGHTING" },
  27: { name: "Rolling Kick", type: "FIGHTING" },
  28: { name: "Sand Attack", type: "GROUND" },
  29: { name: "Headbutt", type: "NORMAL" },
  30: { name: "Horn Attack", type: "NORMAL" },
  31: { name: "Fury Attack", type: "NORMAL" },
  32: { name: "Horn Drill", type: "NORMAL" },
  33: { name: "Tackle", type: "NORMAL" },
  34: { name: "Body Slam", type: "NORMAL" },
  35: { name: "Wrap", type: "NORMAL" },
  36: { name: "Take Down", type: "NORMAL" },
  37: { name: "Thrash", type: "NORMAL" },
  38: { name: "Double-Edge", type: "NORMAL" },
  39: { name: "Tail Whip", type: "NORMAL" },
  40: { name: "Poison Sting", type: "POISON" },
  41: { name: "Twineedle", type: "BUG" },
  42: { name: "Pin Missile", type: "BUG" },
  43: { name: "Leer", type: "NORMAL" },
  44: { name: "Bite", type: "DARK" },
  45: { name: "Growl", type: "NORMAL" },
  46: { name: "Roar", type: "NORMAL" },
  47: { name: "Sing", type: "NORMAL" },
  48: { name: "Supersonic", type: "NORMAL" },
  49: { name: "Sonic Boom", type: "NORMAL" },
  50: { name: "Disable", type: "NORMAL" },
  51: { name: "Acid", type: "POISON" },
  52: { name: "Ember", type: "FIRE" },
  53: { name: "Flamethrower", type: "FIRE" },
  54: { name: "Mist", type: "ICE" },
  55: { name: "Water Gun", type: "WATER" },
  56: { name: "Hydro Pump", type: "WATER" },
  57: { name: "Surf", type: "WATER" },
  58: { name: "Ice Beam", type: "ICE" },
  59: { name: "Blizzard", type: "ICE" },
  60: { name: "Psybeam", type: "PSYCHIC" },
  61: { name: "Bubble Beam", type: "WATER" },
  62: { name: "Aurora Beam", type: "ICE" },
  63: { name: "Hyper Beam", type: "NORMAL" },
  64: { name: "Peck", type: "FLYING" },
  65: { name: "Drill Peck", type: "FLYING" },
  66: { name: "Submission", type: "FIGHTING" },
  67: { name: "Low Kick", type: "FIGHTING" },
  68: { name: "Counter", type: "FIGHTING" },
  69: { name: "Seismic Toss", type: "FIGHTING" },
  70: { name: "Strength", type: "NORMAL" },
  71: { name: "Absorb", type: "GRASS" },
  72: { name: "Mega Drain", type: "GRASS" },
  73: { name: "Leech Seed", type: "GRASS" },
  74: { name: "Growth", type: "GRASS" },
  75: { name: "Razor Leaf", type: "GRASS" },
  76: { name: "Solar Beam", type: "GRASS" },
  77: { name: "Poison Powder", type: "POISON" },
  78: { name: "Stun Spore", type: "GRASS" },
  79: { name: "Sleep Powder", type: "GRASS" },
  80: { name: "Petal Dance", type: "GRASS" },
  81: { name: "String Shot", type: "BUG" },
  82: { name: "Dragon Rage", type: "DRAGON" },
  83: { name: "Fire Spin", type: "FIRE" },
  84: { name: "Thunder Shock", type: "ELECTRIC" },
  85: { name: "Thunderbolt", type: "ELECTRIC" },
  86: { name: "Thunder Wave", type: "ELECTRIC" },
  87: { name: "Thunder", type: "ELECTRIC" },
  88: { name: "Rock Throw", type: "ROCK" },
  89: { name: "Earthquake", type: "GROUND" },
  90: { name: "Fissure", type: "GROUND" },
  91: { name: "Dig", type: "GROUND" },
  92: { name: "Toxic", type: "POISON" },
  93: { name: "Confusion", type: "PSYCHIC" },
  94: { name: "Psychic", type: "PSYCHIC" },
  95: { name: "Hypnosis", type: "PSYCHIC" },
  96: { name: "Meditate", type: "PSYCHIC" },
  97: { name: "Agility", type: "PSYCHIC" },
  98: { name: "Quick Attack", type: "NORMAL" },
  99: { name: "Rage", type: "NORMAL" },
  100: { name: "Teleport", type: "PSYCHIC" },
  101: { name: "Night Shade", type: "GHOST" },
  102: { name: "Mimic", type: "NORMAL" },
  103: { name: "Screech", type: "NORMAL" },
  104: { name: "Double Team", type: "NORMAL" },
  105: { name: "Recover", type: "NORMAL" },
  106: { name: "Harden", type: "NORMAL" },
  107: { name: "Minimize", type: "NORMAL" },
  108: { name: "Smokescreen", type: "NORMAL" },
  109: { name: "Confuse Ray", type: "GHOST" },
  110: { name: "Withdraw", type: "WATER" },
  111: { name: "Defense Curl", type: "NORMAL" },
  112: { name: "Barrier", type: "PSYCHIC" },
  113: { name: "Light Screen", type: "PSYCHIC" },
  114: { name: "Haze", type: "ICE" },
  115: { name: "Reflect", type: "PSYCHIC" },
  116: { name: "Focus Energy", type: "NORMAL" },
  117: { name: "Bide", type: "NORMAL" },
  118: { name: "Metronome", type: "NORMAL" },
  119: { name: "Mirror Move", type: "FLYING" },
  120: { name: "Self-Destruct", type: "NORMAL" },
  121: { name: "Egg Bomb", type: "NORMAL" },
  122: { name: "Lick", type: "GHOST" },
  123: { name: "Smog", type: "POISON" },
  124: { name: "Sludge", type: "POISON" },
  125: { name: "Bone Club", type: "GROUND" },
  126: { name: "Fire Blast", type: "FIRE" },
  127: { name: "Waterfall", type: "WATER" },
  128: { name: "Clamp", type: "WATER" },
  129: { name: "Swift", type: "NORMAL" },
  130: { name: "Skull Bash", type: "NORMAL" },
  131: { name: "Spike Cannon", type: "NORMAL" },
  132: { name: "Constrict", type: "NORMAL" },
  133: { name: "Amnesia", type: "PSYCHIC" },
  134: { name: "Kinesis", type: "PSYCHIC" },
  135: { name: "Soft-Boiled", type: "NORMAL" },
  136: { name: "High Jump Kick", type: "FIGHTING" },
  137: { name: "Glare", type: "NORMAL" },
  138: { name: "Dream Eater", type: "PSYCHIC" },
  139: { name: "Poison Gas", type: "POISON" },
  140: { name: "Barrage", type: "NORMAL" },
  141: { name: "Leech Life", type: "BUG" },
  142: { name: "Lovely Kiss", type: "NORMAL" },
  143: { name: "Sky Attack", type: "FLYING" },
  144: { name: "Transform", type: "NORMAL" },
  145: { name: "Bubble", type: "WATER" },
  146: { name: "Dizzy Punch", type: "NORMAL" },
  147: { name: "Spore", type: "GRASS" },
  148: { name: "Flash", type: "NORMAL" },
  149: { name: "Psywave", type: "PSYCHIC" },
  150: { name: "Splash", type: "NORMAL" },
  151: { name: "Acid Armor", type: "POISON" },
  152: { name: "Crabhammer", type: "WATER" },
  153: { name: "Explosion", type: "NORMAL" },
  154: { name: "Fury Swipes", type: "NORMAL" },
  155: { name: "Bonemerang", type: "GROUND" },
  156: { name: "Rest", type: "PSYCHIC" },
  157: { name: "Rock Slide", type: "ROCK" },
  158: { name: "Hyper Fang", type: "NORMAL" },
  159: { name: "Sharpen", type: "NORMAL" },
  160: { name: "Conversion", type: "NORMAL" },
  161: { name: "Tri Attack", type: "NORMAL" },
  162: { name: "Super Fang", type: "NORMAL" },
  163: { name: "Slash", type: "NORMAL" },
  164: { name: "Substitute", type: "NORMAL" },
  165: { name: "Struggle", type: "NORMAL" },
  166: { name: "Sketch", type: "NORMAL" },
  167: { name: "Triple Kick", type: "FIGHTING" },
  168: { name: "Thief", type: "DARK" },
  169: { name: "Spider Web", type: "BUG" },
  170: { name: "Mind Reader", type: "NORMAL" },
  171: { name: "Nightmare", type: "GHOST" },
  172: { name: "Flame Wheel", type: "FIRE" },
  173: { name: "Snore", type: "NORMAL" },
  174: { name: "Curse", type: "GHOST" },
  175: { name: "Flail", type: "NORMAL" },
  176: { name: "Conversion 2", type: "NORMAL" },
  177: { name: "Aeroblast", type: "FLYING" },
  178: { name: "Cotton Spore", type: "GRASS" },
  179: { name: "Reversal", type: "FIGHTING" },
  180: { name: "Spite", type: "GHOST" },
  181: { name: "Powder Snow", type: "ICE" },
  182: { name: "Protect", type: "NORMAL" },
  183: { name: "Mach Punch", type: "FIGHTING" },
  184: { name: "Scary Face", type: "NORMAL" },
  185: { name: "Feint Attack", type: "DARK" },
  186: { name: "Sweet Kiss", type: "FAIRY" },
  187: { name: "Belly Drum", type: "NORMAL" },
  188: { name: "Sludge Bomb", type: "POISON" },
  189: { name: "Mud-Slap", type: "GROUND" },
  190: { name: "Octazooka", type: "WATER" },
  191: { name: "Spikes", type: "GROUND" },
  192: { name: "Zap Cannon", type: "ELECTRIC" },
  193: { name: "Foresight", type: "NORMAL" },
  194: { name: "Destiny Bond", type: "GHOST" },
  195: { name: "Perish Song", type: "NORMAL" },
  196: { name: "Icy Wind", type: "ICE" },
  197: { name: "Detect", type: "FIGHTING" },
  198: { name: "Bone Rush", type: "GROUND" },
  199: { name: "Lock-On", type: "NORMAL" },
  200: { name: "Outrage", type: "DRAGON" },
  201: { name: "Sandstorm", type: "ROCK" },
  202: { name: "Giga Drain", type: "GRASS" },
  203: { name: "Endure", type: "NORMAL" },
  204: { name: "Charm", type: "FAIRY" },
  205: { name: "Rollout", type: "ROCK" },
  206: { name: "False Swipe", type: "NORMAL" },
  207: { name: "Swagger", type: "NORMAL" },
  208: { name: "Milk Drink", type: "NORMAL" },
  209: { name: "Spark", type: "ELECTRIC" },
  210: { name: "Fury Cutter", type: "BUG" },
  211: { name: "Steel Wing", type: "STEEL" },
  212: { name: "Mean Look", type: "NORMAL" },
  213: { name: "Attract", type: "NORMAL" },
  214: { name: "Sleep Talk", type: "NORMAL" },
  215: { name: "Heal Bell", type: "NORMAL" },
  216: { name: "Return", type: "NORMAL" },
  217: { name: "Present", type: "NORMAL" },
  218: { name: "Frustration", type: "NORMAL" },
  219: { name: "Safeguard", type: "NORMAL" },
  220: { name: "Pain Split", type: "NORMAL" },
  221: { name: "Sacred Fire", type: "FIRE" },
  222: { name: "Magnitude", type: "GROUND" },
  223: { name: "Dynamic Punch", type: "FIGHTING" },
  224: { name: "Megahorn", type: "BUG" },
  225: { name: "Dragon Breath", type: "DRAGON" },
  226: { name: "Baton Pass", type: "NORMAL" },
  227: { name: "Encore", type: "NORMAL" },
  228: { name: "Pursuit", type: "DARK" },
  229: { name: "Rapid Spin", type: "NORMAL" },
  230: { name: "Sweet Scent", type: "NORMAL" },
  231: { name: "Iron Tail", type: "STEEL" },
  232: { name: "Metal Claw", type: "STEEL" },
  233: { name: "Vital Throw", type: "FIGHTING" },
  234: { name: "Morning Sun", type: "NORMAL" },
  235: { name: "Synthesis", type: "GRASS" },
  236: { name: "Moonlight", type: "FAIRY" },
  237: { name: "Hidden Power", type: "NORMAL" },
  238: { name: "Cross Chop", type: "FIGHTING" },
  239: { name: "Twister", type: "DRAGON" },
  240: { name: "Rain Dance", type: "WATER" },
  241: { name: "Sunny Day", type: "FIRE" },
  242: { name: "Crunch", type: "DARK" },
  243: { name: "Mirror Coat", type: "PSYCHIC" },
  244: { name: "Psych Up", type: "NORMAL" },
  245: { name: "Extreme Speed", type: "NORMAL" },
  246: { name: "Ancient Power", type: "ROCK" },
  247: { name: "Shadow Ball", type: "GHOST" },
  248: { name: "Future Sight", type: "PSYCHIC" },
  249: { name: "Rock Smash", type: "FIGHTING" },
  250: { name: "Whirlpool", type: "WATER" },
  251: { name: "Beat Up", type: "DARK" },
  252: { name: "Fake Out", type: "NORMAL" },
  253: { name: "Uproar", type: "NORMAL" },
  254: { name: "Stockpile", type: "NORMAL" },
  255: { name: "Spit Up", type: "NORMAL" },
  256: { name: "Swallow", type: "NORMAL" },
  257: { name: "Heat Wave", type: "FIRE" },
  258: { name: "Hail", type: "ICE" },
  259: { name: "Torment", type: "DARK" },
  260: { name: "Flatter", type: "DARK" },
  261: { name: "Will-O-Wisp", type: "FIRE" },
  262: { name: "Memento", type: "DARK" },
  263: { name: "Facade", type: "NORMAL" },
  264: { name: "Focus Punch", type: "FIGHTING" },
  265: { name: "Smelling Salts", type: "NORMAL" },
  266: { name: "Follow Me", type: "NORMAL" },
  267: { name: "Nature Power", type: "NORMAL" },
  268: { name: "Charge", type: "ELECTRIC" },
  269: { name: "Taunt", type: "DARK" },
  270: { name: "Helping Hand", type: "NORMAL" },
  271: { name: "Trick", type: "PSYCHIC" },
  272: { name: "Role Play", type: "PSYCHIC" },
  273: { name: "Wish", type: "NORMAL" },
  274: { name: "Assist", type: "NORMAL" },
  275: { name: "Ingrain", type: "GRASS" },
  276: { name: "Superpower", type: "FIGHTING" },
  277: { name: "Magic Coat", type: "PSYCHIC" },
  278: { name: "Recycle", type: "NORMAL" },
  279: { name: "Revenge", type: "FIGHTING" },
  280: { name: "Brick Break", type: "FIGHTING" },
  281: { name: "Yawn", type: "NORMAL" },
  282: { name: "Knock Off", type: "DARK" },
  283: { name: "Endeavor", type: "NORMAL" },
  284: { name: "Eruption", type: "FIRE" },
  285: { name: "Skill Swap", type: "PSYCHIC" },
  286: { name: "Imprison", type: "PSYCHIC" },
  287: { name: "Refresh", type: "NORMAL" },
  288: { name: "Grudge", type: "GHOST" },
  289: { name: "Snatch", type: "DARK" },
  290: { name: "Secret Power", type: "NORMAL" },
  291: { name: "Dive", type: "WATER" },
  292: { name: "Arm Thrust", type: "FIGHTING" },
  293: { name: "Camouflage", type: "NORMAL" },
  294: { name: "Tail Glow", type: "BUG" },
  295: { name: "Luster Purge", type: "PSYCHIC" },
  296: { name: "Mist Ball", type: "PSYCHIC" },
  297: { name: "Feather Dance", type: "FLYING" },
  298: { name: "Teeter Dance", type: "NORMAL" },
  299: { name: "Blaze Kick", type: "FIRE" },
  300: { name: "Mud Sport", type: "GROUND" },
  301: { name: "Ice Ball", type: "ICE" },
  302: { name: "Needle Arm", type: "GRASS" },
  303: { name: "Slack Off", type: "NORMAL" },
  304: { name: "Hyper Voice", type: "NORMAL" },
  305: { name: "Poison Fang", type: "POISON" },
  306: { name: "Crush Claw", type: "NORMAL" },
  307: { name: "Blast Burn", type: "FIRE" },
  308: { name: "Hydro Cannon", type: "WATER" },
  309: { name: "Meteor Mash", type: "STEEL" },
  310: { name: "Astonish", type: "GHOST" },
  311: { name: "Weather Ball", type: "NORMAL" },
  312: { name: "Aromatherapy", type: "GRASS" },
  313: { name: "Fake Tears", type: "DARK" },
  314: { name: "Air Cutter", type: "FLYING" },
  315: { name: "Overheat", type: "FIRE" },
  316: { name: "Odor Sleuth", type: "NORMAL" },
  317: { name: "Rock Tomb", type: "ROCK" },
  318: { name: "Silver Wind", type: "BUG" },
  319: { name: "Metal Sound", type: "STEEL" },
  320: { name: "Grass Whistle", type: "GRASS" },
  321: { name: "Tickle", type: "NORMAL" },
  322: { name: "Cosmic Power", type: "PSYCHIC" },
  323: { name: "Water Spout", type: "WATER" },
  324: { name: "Signal Beam", type: "BUG" },
  325: { name: "Shadow Punch", type: "GHOST" },
  326: { name: "Extrasensory", type: "PSYCHIC" },
  327: { name: "Sky Uppercut", type: "FIGHTING" },
  328: { name: "Sand Tomb", type: "GROUND" },
  329: { name: "Sheer Cold", type: "ICE" },
  330: { name: "Muddy Water", type: "WATER" },
  331: { name: "Bullet Seed", type: "GRASS" },
  332: { name: "Aerial Ace", type: "FLYING" },
  333: { name: "Icicle Spear", type: "ICE" },
  334: { name: "Iron Defense", type: "STEEL" },
  335: { name: "Block", type: "NORMAL" },
  336: { name: "Howl", type: "NORMAL" },
  337: { name: "Dragon Claw", type: "DRAGON" },
  338: { name: "Frenzy Plant", type: "GRASS" },
  339: { name: "Bulk Up", type: "FIGHTING" },
  340: { name: "Bounce", type: "FLYING" },
  341: { name: "Mud Shot", type: "GROUND" },
  342: { name: "Poison Tail", type: "POISON" },
  343: { name: "Covet", type: "NORMAL" },
  344: { name: "Volt Tackle", type: "ELECTRIC" },
  345: { name: "Magical Leaf", type: "GRASS" },
  346: { name: "Water Sport", type: "WATER" },
  347: { name: "Calm Mind", type: "PSYCHIC" },
  348: { name: "Leaf Blade", type: "GRASS" },
  349: { name: "Dragon Dance", type: "DRAGON" },
  350: { name: "Rock Blast", type: "ROCK" },
  351: { name: "Shock Wave", type: "ELECTRIC" },
  352: { name: "Water Pulse", type: "WATER" },
  353: { name: "Doom Desire", type: "STEEL" },
  354: { name: "Psycho Boost", type: "PSYCHIC" },
  355: { name: "Roost", type: "FLYING" },
  356: { name: "Gravity", type: "PSYCHIC" },
  357: { name: "Miracle Eye", type: "PSYCHIC" },
  358: { name: "Wake-Up Slap", type: "FIGHTING" },
  359: { name: "Hammer Arm", type: "FIGHTING" },
  360: { name: "Gyro Ball", type: "STEEL" },
  361: { name: "Healing Wish", type: "PSYCHIC" },
  362: { name: "Brine", type: "WATER" },
  363: { name: "Natural Gift", type: "NORMAL" },
  364: { name: "Feint", type: "NORMAL" },
  365: { name: "Pluck", type: "FLYING" },
  366: { name: "Tailwind", type: "FLYING" },
  367: { name: "Acupressure", type: "NORMAL" },
  368: { name: "Metal Burst", type: "STEEL" },
  369: { name: "U-turn", type: "BUG" },
  370: { name: "Close Combat", type: "FIGHTING" },
  371: { name: "Payback", type: "DARK" },
  372: { name: "Assurance", type: "DARK" },
  373: { name: "Embargo", type: "DARK" },
  374: { name: "Fling", type: "DARK" },
  375: { name: "Psycho Shift", type: "PSYCHIC" },
  376: { name: "Trump Card", type: "NORMAL" },
  377: { name: "Heal Block", type: "PSYCHIC" },
  378: { name: "Wring Out", type: "NORMAL" },
  379: { name: "Power Trick", type: "PSYCHIC" },
  380: { name: "Gastro Acid", type: "POISON" },
  381: { name: "Lucky Chant", type: "NORMAL" },
  382: { name: "Me First", type: "NORMAL" },
  383: { name: "Copycat", type: "NORMAL" },
  384: { name: "Power Swap", type: "PSYCHIC" },
  385: { name: "Guard Swap", type: "PSYCHIC" },
  386: { name: "Punishment", type: "DARK" },
  387: { name: "Last Resort", type: "NORMAL" },
  388: { name: "Worry Seed", type: "GRASS" },
  389: { name: "Sucker Punch", type: "DARK" },
  390: { name: "Toxic Spikes", type: "POISON" },
  391: { name: "Heart Swap", type: "PSYCHIC" },
  392: { name: "Aqua Ring", type: "WATER" },
  393: { name: "Magnet Rise", type: "ELECTRIC" },
  394: { name: "Flare Blitz", type: "FIRE" },
  395: { name: "Force Palm", type: "FIGHTING" },
  396: { name: "Aura Sphere", type: "FIGHTING" },
  397: { name: "Rock Polish", type: "ROCK" },
  398: { name: "Poison Jab", type: "POISON" },
  399: { name: "Dark Pulse", type: "DARK" },
  400: { name: "Night Slash", type: "DARK" },
  401: { name: "Aqua Tail", type: "WATER" },
  402: { name: "Seed Bomb", type: "GRASS" },
  403: { name: "Air Slash", type: "FLYING" },
  404: { name: "X-Scissor", type: "BUG" },
  405: { name: "Bug Buzz", type: "BUG" },
  406: { name: "Dragon Pulse", type: "DRAGON" },
  407: { name: "Dragon Rush", type: "DRAGON" },
  408: { name: "Power Gem", type: "ROCK" },
  409: { name: "Drain Punch", type: "FIGHTING" },
  410: { name: "Vacuum Wave", type: "FIGHTING" },
  411: { name: "Focus Blast", type: "FIGHTING" },
  412: { name: "Energy Ball", type: "GRASS" },
  413: { name: "Brave Bird", type: "FLYING" },
  414: { name: "Earth Power", type: "GROUND" },
  415: { name: "Switcheroo", type: "DARK" },
  416: { name: "Giga Impact", type: "NORMAL" },
  417: { name: "Nasty Plot", type: "DARK" },
  418: { name: "Bullet Punch", type: "STEEL" },
  419: { name: "Avalanche", type: "ICE" },
  420: { name: "Ice Shard", type: "ICE" },
  421: { name: "Shadow Claw", type: "GHOST" },
  422: { name: "Thunder Fang", type: "ELECTRIC" },
  423: { name: "Ice Fang", type: "ICE" },
  424: { name: "Fire Fang", type: "FIRE" },
  425: { name: "Shadow Sneak", type: "GHOST" },
  426: { name: "Mud Bomb", type: "GROUND" },
  427: { name: "Psycho Cut", type: "PSYCHIC" },
  428: { name: "Zen Headbutt", type: "PSYCHIC" },
  429: { name: "Mirror Shot", type: "STEEL" },
  430: { name: "Flash Cannon", type: "STEEL" },
  431: { name: "Rock Climb", type: "NORMAL" },
  432: { name: "Defog", type: "FLYING" },
  433: { name: "Trick Room", type: "PSYCHIC" },
  434: { name: "Draco Meteor", type: "DRAGON" },
  435: { name: "Discharge", type: "ELECTRIC" },
  436: { name: "Lava Plume", type: "FIRE" },
  437: { name: "Leaf Storm", type: "GRASS" },
  438: { name: "Power Whip", type: "GRASS" },
  439: { name: "Rock Wrecker", type: "ROCK" },
  440: { name: "Cross Poison", type: "POISON" },
  441: { name: "Gunk Shot", type: "POISON" },
  442: { name: "Iron Head", type: "STEEL" },
  443: { name: "Magnet Bomb", type: "STEEL" },
  444: { name: "Stone Edge", type: "ROCK" },
  445: { name: "Captivate", type: "NORMAL" },
  446: { name: "Stealth Rock", type: "ROCK" },
  447: { name: "Grass Knot", type: "GRASS" },
  448: { name: "Chatter", type: "FLYING" },
  449: { name: "Judgment", type: "NORMAL" },
  450: { name: "Bug Bite", type: "BUG" },
  451: { name: "Charge Beam", type: "ELECTRIC" },
  452: { name: "Wood Hammer", type: "GRASS" },
  453: { name: "Aqua Jet", type: "WATER" },
  454: { name: "Attack Order", type: "BUG" },
  455: { name: "Defend Order", type: "BUG" },
  456: { name: "Heal Order", type: "BUG" },
  457: { name: "Head Smash", type: "ROCK" },
  458: { name: "Double Hit", type: "NORMAL" },
  459: { name: "Roar of Time", type: "DRAGON" },
  460: { name: "Spacial Rend", type: "DRAGON" },
  461: { name: "Lunar Dance", type: "PSYCHIC" },
  462: { name: "Crush Grip", type: "NORMAL" },
  463: { name: "Magma Storm", type: "FIRE" },
  464: { name: "Dark Void", type: "DARK" },
  465: { name: "Seed Flare", type: "GRASS" },
  466: { name: "Ominous Wind", type: "GHOST" },
  467: { name: "Shadow Force", type: "GHOST" },
  468: { name: "Hone Claws", type: "DARK" },
  469: { name: "Wide Guard", type: "ROCK" },
  470: { name: "Guard Split", type: "PSYCHIC" },
  471: { name: "Power Split", type: "PSYCHIC" },
  472: { name: "Wonder Room", type: "PSYCHIC" },
  473: { name: "Psyshock", type: "PSYCHIC" },
  474: { name: "Venoshock", type: "POISON" },
  475: { name: "Autotomize", type: "STEEL" },
  476: { name: "Rage Powder", type: "BUG" },
  477: { name: "Telekinesis", type: "PSYCHIC" },
  478: { name: "Magic Room", type: "PSYCHIC" },
  479: { name: "Smack Down", type: "ROCK" },
  480: { name: "Storm Throw", type: "FIGHTING" },
  481: { name: "Flame Burst", type: "FIRE" },
  482: { name: "Sludge Wave", type: "POISON" },
  483: { name: "Quiver Dance", type: "BUG" },
  484: { name: "Heavy Slam", type: "STEEL" },
  485: { name: "Synchronoise", type: "PSYCHIC" },
  486: { name: "Electro Ball", type: "ELECTRIC" },
  487: { name: "Soak", type: "WATER" },
  488: { name: "Flame Charge", type: "FIRE" },
  489: { name: "Coil", type: "POISON" },
  490: { name: "Low Sweep", type: "FIGHTING" },
  491: { name: "Acid Spray", type: "POISON" },
  492: { name: "Foul Play", type: "DARK" },
  493: { name: "Simple Beam", type: "NORMAL" },
  494: { name: "Entrainment", type: "NORMAL" },
  495: { name: "After You", type: "NORMAL" },
  496: { name: "Round", type: "NORMAL" },
  497: { name: "Echoed Voice", type: "NORMAL" },
  498: { name: "Chip Away", type: "NORMAL" },
  499: { name: "Clear Smog", type: "POISON" },
  500: { name: "Stored Power", type: "PSYCHIC" },
  501: { name: "Quick Guard", type: "FIGHTING" },
  502: { name: "Ally Switch", type: "PSYCHIC" },
  503: { name: "Scald", type: "WATER" },
  504: { name: "Shell Smash", type: "NORMAL" },
  505: { name: "Heal Pulse", type: "PSYCHIC" },
  506: { name: "Hex", type: "GHOST" },
  507: { name: "Sky Drop", type: "FLYING" },
  508: { name: "Shift Gear", type: "STEEL" },
  509: { name: "Circle Throw", type: "FIGHTING" },
  510: { name: "Incinerate", type: "FIRE" },
  511: { name: "Quash", type: "DARK" },
  512: { name: "Acrobatics", type: "FLYING" },
  513: { name: "Reflect Type", type: "NORMAL" },
  514: { name: "Retaliate", type: "NORMAL" },
  515: { name: "Final Gambit", type: "FIGHTING" },
  516: { name: "Bestow", type: "NORMAL" },
  517: { name: "Inferno", type: "FIRE" },
  518: { name: "Water Pledge", type: "WATER" },
  519: { name: "Fire Pledge", type: "FIRE" },
  520: { name: "Grass Pledge", type: "GRASS" },
  521: { name: "Volt Switch", type: "ELECTRIC" },
  522: { name: "Struggle Bug", type: "BUG" },
  523: { name: "Bulldoze", type: "GROUND" },
  524: { name: "Frost Breath", type: "ICE" },
  525: { name: "Dragon Tail", type: "DRAGON" },
  526: { name: "Work Up", type: "NORMAL" },
  527: { name: "Electroweb", type: "ELECTRIC" },
  528: { name: "Wild Charge", type: "ELECTRIC" },
  529: { name: "Drill Run", type: "GROUND" },
  530: { name: "Dual Chop", type: "DRAGON" },
  531: { name: "Heart Stamp", type: "PSYCHIC" },
  532: { name: "Horn Leech", type: "GRASS" },
  533: { name: "Sacred Sword", type: "FIGHTING" },
  534: { name: "Razor Shell", type: "WATER" },
  535: { name: "Heat Crash", type: "FIRE" },
  536: { name: "Leaf Tornado", type: "GRASS" },
  537: { name: "Steamroller", type: "BUG" },
  538: { name: "Cotton Guard", type: "GRASS" },
  539: { name: "Night Daze", type: "DARK" },
  540: { name: "Psystrike", type: "PSYCHIC" },
  541: { name: "Tail Slap", type: "NORMAL" },
  542: { name: "Hurricane", type: "FLYING" },
  543: { name: "Head Charge", type: "NORMAL" },
  544: { name: "Gear Grind", type: "STEEL" },
  545: { name: "Searing Shot", type: "FIRE" },
  546: { name: "Techno Blast", type: "NORMAL" },
  547: { name: "Relic Song", type: "NORMAL" },
  548: { name: "Secret Sword", type: "FIGHTING" },
  549: { name: "Glaciate", type: "ICE" },
  550: { name: "Bolt Strike", type: "ELECTRIC" },
  551: { name: "Blue Flare", type: "FIRE" },
  552: { name: "Fiery Dance", type: "FIRE" },
  553: { name: "Freeze Shock", type: "ICE" },
  554: { name: "Ice Burn", type: "ICE" },
  555: { name: "Snarl", type: "DARK" },
  556: { name: "Icicle Crash", type: "ICE" },
  557: { name: "V-create", type: "FIRE" },
  558: { name: "Fusion Flare", type: "FIRE" },
  559: { name: "Fusion Bolt", type: "ELECTRIC" },
  560: { name: "Flying Press", type: "FIGHTING" },
  561: { name: "Mat Block", type: "FIGHTING" },
  562: { name: "Belch", type: "POISON" },
  563: { name: "Rototiller", type: "GROUND" },
  564: { name: "Sticky Web", type: "BUG" },
  565: { name: "Fell Stinger", type: "BUG" },
  566: { name: "Phantom Force", type: "GHOST" },
  567: { name: "Trick-or-Treat", type: "GHOST" },
  568: { name: "Noble Roar", type: "NORMAL" },
  569: { name: "Ion Deluge", type: "ELECTRIC" },
  570: { name: "Parabolic Charge", type: "ELECTRIC" },
  571: { name: "Forest's Curse", type: "GRASS" },
  572: { name: "Petal Blizzard", type: "GRASS" },
  573: { name: "Freeze-Dry", type: "ICE" },
  574: { name: "Disarming Voice", type: "FAIRY" },
  575: { name: "Parting Shot", type: "DARK" },
  576: { name: "Topsy-Turvy", type: "DARK" },
  577: { name: "Draining Kiss", type: "FAIRY" },
  578: { name: "Crafty Shield", type: "FAIRY" },
  579: { name: "Flower Shield", type: "FAIRY" },
  580: { name: "Grassy Terrain", type: "GRASS" },
  581: { name: "Misty Terrain", type: "FAIRY" },
  582: { name: "Electrify", type: "ELECTRIC" },
  583: { name: "Play Rough", type: "FAIRY" },
  584: { name: "Fairy Wind", type: "FAIRY" },
  585: { name: "Moonblast", type: "FAIRY" },
  586: { name: "Boomburst", type: "NORMAL" },
  587: { name: "Fairy Lock", type: "FAIRY" },
  588: { name: "King's Shield", type: "STEEL" },
  589: { name: "Play Nice", type: "NORMAL" },
  590: { name: "Confide", type: "NORMAL" },
  591: { name: "Diamond Storm", type: "ROCK" },
  592: { name: "Steam Eruption", type: "WATER" },
  593: { name: "Hyperspace Hole", type: "PSYCHIC" },
  594: { name: "Water Shuriken", type: "WATER" },
  595: { name: "Mystical Fire", type: "FIRE" },
  596: { name: "Spiky Shield", type: "GRASS" },
  597: { name: "Aromatic Mist", type: "FAIRY" },
  598: { name: "Eerie Impulse", type: "ELECTRIC" },
  599: { name: "Venom Drench", type: "POISON" },
  600: { name: "Powder", type: "BUG" },
  601: { name: "Geomancy", type: "FAIRY" },
  602: { name: "Magnetic Flux", type: "ELECTRIC" },
  603: { name: "Happy Hour", type: "NORMAL" },
  604: { name: "Electric Terrain", type: "ELECTRIC" },
  605: { name: "Dazzling Gleam", type: "FAIRY" },
  606: { name: "Celebrate", type: "NORMAL" },
  607: { name: "Hold Hands", type: "NORMAL" },
  608: { name: "Baby-Doll Eyes", type: "FAIRY" },
  609: { name: "Nuzzle", type: "ELECTRIC" },
  610: { name: "Hold Back", type: "NORMAL" },
  611: { name: "Infestation", type: "BUG" },
  612: { name: "Power-Up Punch", type: "FIGHTING" },
  613: { name: "Oblivion Wing", type: "FLYING" },
  614: { name: "Thousand Arrows", type: "GROUND" },
  615: { name: "Thousand Waves", type: "GROUND" },
  616: { name: "Land's Wrath", type: "GROUND" },
  617: { name: "Light Of Ruin", type: "FAIRY" },
  618: { name: "Origin Pulse", type: "WATER" },
  619: { name: "Precipice Blades", type: "GROUND" },
  620: { name: "Dragon Ascent", type: "FLYING" },
  621: { name: "Hyperspace Fury", type: "DARK" },
  622: { name: "Shore Up", type: "GROUND" },
  623: { name: "First Impression", type: "BUG" },
  624: { name: "Baneful Bunker", type: "POISON" },
  625: { name: "Spirit Shackle", type: "GHOST" },
  626: { name: "Darkest Lariat", type: "DARK" },
  627: { name: "Sparkling Aria", type: "WATER" },
  628: { name: "Ice Hammer", type: "ICE" },
  629: { name: "Floral Healing", type: "FAIRY" },
  630: { name: "High Horsepower", type: "GROUND" },
  631: { name: "Strength Sap", type: "GRASS" },
  632: { name: "Solar Blade", type: "GRASS" },
  633: { name: "Leafage", type: "GRASS" },
  634: { name: "Spotlight", type: "NORMAL" },
  635: { name: "Toxic Thread", type: "POISON" },
  636: { name: "Laser Focus", type: "NORMAL" },
  637: { name: "Gear Up", type: "STEEL" },
  638: { name: "Throat Chop", type: "DARK" },
  639: { name: "Pollen Puff", type: "BUG" },
  640: { name: "Anchor Shot", type: "STEEL" },
  641: { name: "Psychic Terrain", type: "PSYCHIC" },
  642: { name: "Lunge", type: "BUG" },
  643: { name: "Fire Lash", type: "FIRE" },
  644: { name: "Power Trip", type: "DARK" },
  645: { name: "Burn Up", type: "FIRE" },
  646: { name: "Speed Swap", type: "PSYCHIC" },
  647: { name: "Smart Strike", type: "STEEL" },
  648: { name: "Purify", type: "POISON" },
  649: { name: "Revelation Dance", type: "NORMAL" },
  650: { name: "Core Enforcer", type: "DRAGON" },
  651: { name: "Trop Kick", type: "GRASS" },
  652: { name: "Instruct", type: "PSYCHIC" },
  653: { name: "Beak Blast", type: "FLYING" },
  654: { name: "Clanging Scales", type: "DRAGON" },
  655: { name: "Dragon Hammer", type: "DRAGON" },
  656: { name: "Brutal Swing", type: "DARK" },
  657: { name: "Aurora Veil", type: "ICE" },
  658: { name: "Shell Trap", type: "FIRE" },
  659: { name: "Fleur Cannon", type: "FAIRY" },
  660: { name: "Psychic Fangs", type: "PSYCHIC" },
  661: { name: "Stomping Tantrum", type: "GROUND" },
  662: { name: "Shadow Bone", type: "GHOST" },
  663: { name: "Accelerock", type: "ROCK" },
  664: { name: "Liquidation", type: "WATER" },
  665: { name: "Prismatic Laser", type: "PSYCHIC" },
  666: { name: "Spectral Thief", type: "GHOST" },
  667: { name: "Sunsteel Strike", type: "STEEL" },
  668: { name: "Moongeist Beam", type: "GHOST" },
  669: { name: "Tearful Look", type: "NORMAL" },
  670: { name: "Zing Zap", type: "ELECTRIC" },
  671: { name: "Nature's Madness", type: "FAIRY" },
  672: { name: "Multi-Attack", type: "NORMAL" },
  673: { name: "Mind Blown", type: "FIRE" },
  674: { name: "Plasma Fists", type: "ELECTRIC" },
  675: { name: "Photon Geyser", type: "PSYCHIC" },
  676: { name: "Zippy Zap", type: "ELECTRIC" },
  677: { name: "Splishy Splash", type: "WATER" },
  678: { name: "Floaty Fall", type: "FLYING" },
  679: { name: "Pika Papow", type: "ELECTRIC" },
  680: { name: "Bouncy Bubble", type: "WATER" },
  681: { name: "Buzzy Buzz", type: "ELECTRIC" },
  682: { name: "Sizzly Slide", type: "FIRE" },
  683: { name: "Glitzy Glow", type: "PSYCHIC" },
  684: { name: "Baddy Bad", type: "DARK" },
  685: { name: "Sappy Seed", type: "GRASS" },
  686: { name: "Freezy Frost", type: "ICE" },
  687: { name: "Sparkly Swirl", type: "FAIRY" },
  688: { name: "Veevee Volley", type: "NORMAL" },
  689: { name: "Double Iron Bash", type: "STEEL" },
  690: { name: "Dynamax Cannon", type: "DRAGON" },
  691: { name: "Snipe Shot", type: "WATER" },
  692: { name: "Jaw Lock", type: "DARK" },
  693: { name: "Stuff Cheeks", type: "NORMAL" },
  694: { name: "No Retreat", type: "FIGHTING" },
  695: { name: "Tar Shot", type: "ROCK" },
  696: { name: "Magic Powder", type: "PSYCHIC" },
  697: { name: "Dragon Darts", type: "DRAGON" },
  698: { name: "Teatime", type: "NORMAL" },
  699: { name: "Octolock", type: "FIGHTING" },
  700: { name: "Bolt Beak", type: "ELECTRIC" },
  701: { name: "Fishious Rend", type: "WATER" },
  702: { name: "Court Change", type: "NORMAL" },
  703: { name: "Clangorous Soul", type: "DRAGON" },
  704: { name: "Body Press", type: "FIGHTING" },
  705: { name: "Decorate", type: "FAIRY" },
  706: { name: "Drum Beating", type: "GRASS" },
  707: { name: "Snap Trap", type: "GRASS" },
  708: { name: "Pyro Ball", type: "FIRE" },
  709: { name: "Behemoth Blade", type: "STEEL" },
  710: { name: "Behemoth Bash", type: "STEEL" },
  711: { name: "Aura Wheel", type: "ELECTRIC" },
  712: { name: "Breaking Swipe", type: "DRAGON" },
  713: { name: "Branch Poke", type: "GRASS" },
  714: { name: "Overdrive", type: "ELECTRIC" },
  715: { name: "Apple Acid", type: "GRASS" },
  716: { name: "Grav Apple", type: "GRASS" },
  717: { name: "Spirit Break", type: "FAIRY" },
  718: { name: "Strange Steam", type: "FAIRY" },
  719: { name: "Life Dew", type: "WATER" },
  720: { name: "Obstruct", type: "DARK" },
  721: { name: "False Surrender", type: "DARK" },
  722: { name: "Meteor Assault", type: "FIGHTING" },
  723: { name: "Eternabeam", type: "DRAGON" },
  724: { name: "Steel Beam", type: "STEEL" },
  725: { name: "Expanding Force", type: "PSYCHIC" },
  726: { name: "Steel Roller", type: "STEEL" },
  727: { name: "Scale Shot", type: "DRAGON" },
  728: { name: "Meteor Beam", type: "ROCK" },
  729: { name: "Shell Side Arm", type: "POISON" },
  730: { name: "Misty Explosion", type: "FAIRY" },
  731: { name: "Grassy Glide", type: "GRASS" },
  732: { name: "Rising Voltage", type: "ELECTRIC" },
  733: { name: "Terrain Pulse", type: "NORMAL" },
  734: { name: "Skitter Smack", type: "BUG" },
  735: { name: "Burning Jealousy", type: "FIRE" },
  736: { name: "Lash Out", type: "DARK" },
  737: { name: "Poltergeist", type: "GHOST" },
  738: { name: "Corrosive Gas", type: "POISON" },
  739: { name: "Coaching", type: "FIGHTING" },
  740: { name: "Flip Turn", type: "WATER" },
  741: { name: "Triple Axel", type: "ICE" },
  742: { name: "Dual Wingbeat", type: "FLYING" },
  743: { name: "Scorching Sands", type: "GROUND" },
  744: { name: "Jungle Healing", type: "GRASS" },
  745: { name: "Wicked Blow", type: "DARK" },
  746: { name: "Surging Strikes", type: "WATER" },
  747: { name: "Thunder Cage", type: "ELECTRIC" },
  748: { name: "Dragon Energy", type: "DRAGON" },
  749: { name: "Freezing Glare", type: "PSYCHIC" },
  750: { name: "Fiery Wrath", type: "DARK" },
  751: { name: "Thunderous Kick", type: "FIGHTING" },
  752: { name: "Glacial Lance", type: "ICE" },
  753: { name: "Astral Barrage", type: "GHOST" },
  754: { name: "Eerie Spell", type: "PSYCHIC" },
  755: { name: "Dire Claw", type: "POISON" },
  756: { name: "Psyshield Bash", type: "PSYCHIC" },
  757: { name: "Power Shift", type: "NORMAL" },
  758: { name: "Stone Axe", type: "ROCK" },
  759: { name: "Springtide Storm", type: "FAIRY" },
  760: { name: "Mystical Power", type: "PSYCHIC" },
  761: { name: "Raging Fury", type: "FIRE" },
  762: { name: "Wave Crash", type: "WATER" },
  763: { name: "Chloroblast", type: "GRASS" },
  764: { name: "Mountain Gale", type: "ICE" },
  765: { name: "Victory Dance", type: "FIGHTING" },
  766: { name: "Headlong Rush", type: "GROUND" },
  767: { name: "Barb Barrage", type: "POISON" },
  768: { name: "Esper Wing", type: "PSYCHIC" },
  769: { name: "Bitter Malice", type: "GHOST" },
  770: { name: "Shelter", type: "STEEL" },
  771: { name: "Triple Arrows", type: "FIGHTING" },
  772: { name: "Infernal Parade", type: "GHOST" },
  773: { name: "Ceaseless Edge", type: "DARK" },
  774: { name: "Bleakwind Storm", type: "FLYING" },
  775: { name: "Wildbolt Storm", type: "ELECTRIC" },
  776: { name: "Sandsear Storm", type: "GROUND" },
  777: { name: "Lunar Blessing", type: "PSYCHIC" },
  778: { name: "Take Heart", type: "PSYCHIC" },
  779: { name: "Tera Blast", type: "NORMAL" },
  780: { name: "Silk Trap", type: "BUG" },
  781: { name: "Axe Kick", type: "FIGHTING" },
  782: { name: "Last Respects", type: "GHOST" },
  783: { name: "Lumina Crash", type: "PSYCHIC" },
  784: { name: "Order Up", type: "DRAGON" },
  785: { name: "Jet Punch", type: "WATER" },
  786: { name: "Spicy Extract", type: "GRASS" },
  787: { name: "Spin Out", type: "STEEL" },
  788: { name: "Population Bomb", type: "NORMAL" },
  789: { name: "Ice Spinner", type: "ICE" },
  790: { name: "Glaive Rush", type: "DRAGON" },
  791: { name: "Revival Blessing", type: "NORMAL" },
  792: { name: "Salt Cure", type: "ROCK" },
  793: { name: "Triple Dive", type: "WATER" },
  794: { name: "Mortal Spin", type: "POISON" },
  795: { name: "Doodle", type: "NORMAL" },
  796: { name: "Fillet Away", type: "NORMAL" },
  797: { name: "Kowtow Cleave", type: "DARK" },
  798: { name: "Flower Trick", type: "GRASS" },
  799: { name: "Torch Song", type: "FIRE" },
  800: { name: "Aqua Step", type: "WATER" },
  801: { name: "Raging Bull", type: "NORMAL" },
  802: { name: "Make It Rain", type: "STEEL" },
  803: { name: "Ruination", type: "DARK" },
  804: { name: "Collision Course", type: "FIGHTING" },
  805: { name: "Electro Drift", type: "ELECTRIC" },
  806: { name: "Shed Tail", type: "NORMAL" },
  807: { name: "Chilly Reception", type: "ICE" },
  808: { name: "Tidy Up", type: "NORMAL" },
  809: { name: "Snowscape", type: "ICE" },
  810: { name: "Pounce", type: "BUG" },
  811: { name: "Trailblaze", type: "GRASS" },
  812: { name: "Chilling Water", type: "WATER" },
  813: { name: "Hyper Drill", type: "NORMAL" },
  814: { name: "Twin Beam", type: "PSYCHIC" },
  815: { name: "Rage Fist", type: "GHOST" },
  816: { name: "Armor Cannon", type: "FIRE" },
  817: { name: "Bitter Blade", type: "FIRE" },
  818: { name: "Double Shock", type: "ELECTRIC" },
  819: { name: "Gigaton Hammer", type: "STEEL" },
  820: { name: "Comeuppance", type: "DARK" },
  821: { name: "Aqua Cutter", type: "WATER" },
  822: { name: "Blazing Torque", type: "FIRE" },
  823: { name: "Wicked Torque", type: "DARK" },
  824: { name: "Noxious Torque", type: "POISON" },
  825: { name: "Combat Torque", type: "FIGHTING" },
  826: { name: "Magical Torque", type: "FAIRY" },
  827: { name: "Psyblade", type: "PSYCHIC" },
  828: { name: "Hydro Steam", type: "WATER" },
  829: { name: "Blood Moon", type: "NORMAL" },
  830: { name: "Matcha Gotcha", type: "GRASS" },
  831: { name: "Syrup Bomb", type: "GRASS" },
  832: { name: "Ivy Cudgel", type: "GRASS" },
  833: { name: "Electro Shot", type: "ELECTRIC" },
  834: { name: "Tera Starstorm", type: "NORMAL" },
  835: { name: "Fickle Beam", type: "DRAGON" },
  836: { name: "Burning Bulwark", type: "FIRE" },
  837: { name: "Thunderclap", type: "ELECTRIC" },
  838: { name: "Mighty Cleave", type: "ROCK" },
  839: { name: "Tachyon Cutter", type: "STEEL" },
  840: { name: "Hard Press", type: "STEEL" },
  841: { name: "Dragon Cheer", type: "DRAGON" },
  842: { name: "Alluring Voice", type: "FAIRY" },
  843: { name: "Temper Flare", type: "FIRE" },
  844: { name: "Supercell Slam", type: "ELECTRIC" },
  845: { name: "Psychic Noise", type: "PSYCHIC" },
  846: { name: "Upper Hand", type: "FIGHTING" },
  847: { name: "Malignant Chain", type: "POISON" },
  848: { name: "Breakneck Blitz", type: "NORMAL" },
  849: { name: "All-Out Pummeling", type: "FIGHTING" },
  850: { name: "Supersonic Skystrike", type: "FLYING" },
  851: { name: "Acid Downpour", type: "POISON" },
  852: { name: "Tectonic Rage", type: "GROUND" },
  853: { name: "Continental Crush", type: "ROCK" },
  854: { name: "Savage Spin-Out", type: "BUG" },
  855: { name: "Never-Ending Nightmare", type: "GHOST" },
  856: { name: "Corkscrew Crash", type: "STEEL" },
  857: { name: "Inferno Overdrive", type: "FIRE" },
  858: { name: "Hydro Vortex", type: "WATER" },
  859: { name: "Bloom Doom", type: "GRASS" },
  860: { name: "Gigavolt Havoc", type: "ELECTRIC" },
  861: { name: "Shattered Psyche", type: "PSYCHIC" },
  862: { name: "Subzero Slammer", type: "ICE" },
  863: { name: "Devastating Drake", type: "DRAGON" },
  864: { name: "Black Hole Eclipse", type: "DARK" },
  865: { name: "Twinkle Tackle", type: "FAIRY" },
  866: { name: "Catastropika", type: "ELECTRIC" },
  867: { name: "10,000,000 Volt Thunderbolt", type: "ELECTRIC" },
  868: { name: "Stoked Sparksurfer", type: "ELECTRIC" },
  869: { name: "Extreme Evoboost", type: "NORMAL" },
  870: { name: "Pulverizing Pancake", type: "NORMAL" },
  871: { name: "Genesis Supernova", type: "PSYCHIC" },
  872: { name: "Sinister Arrow Raid", type: "GHOST" },
  873: { name: "Malicious Moonsault", type: "DARK" },
  874: { name: "Oceanic Operetta", type: "WATER" },
  875: { name: "Splintered Stormshards", type: "ROCK" },
  876: { name: "Let's Snuggle Forever", type: "FAIRY" },
  877: { name: "Clangorous Soulblaze", type: "DRAGON" },
  878: { name: "Guardian of Alola", type: "FAIRY" },
  879: { name: "Searing Sunraze Smash", type: "STEEL" },
  880: { name: "Menacing Moonraze Maelstrom", type: "GHOST" },
  881: { name: "Light That Burns the Sky", type: "PSYCHIC" },
  882: { name: "Soul-Stealing 7-Star Strike", type: "GHOST" },
  883: { name: "Max Guard", type: "NORMAL" },
  884: { name: "Max Strike", type: "NORMAL" },
  885: { name: "Max Knuckle", type: "FIGHTING" },
  886: { name: "Max Airstream", type: "FLYING" },
  887: { name: "Max Ooze", type: "POISON" },
  888: { name: "Max Quake", type: "GROUND" },
  889: { name: "Max Rockfall", type: "ROCK" },
  890: { name: "Max Flutterby", type: "BUG" },
  891: { name: "Max Phantasm", type: "GHOST" },
  892: { name: "Max Steelspike", type: "STEEL" },
  893: { name: "Max Flare", type: "FIRE" },
  894: { name: "Max Geyser", type: "WATER" },
  895: { name: "Max Overgrowth", type: "GRASS" },
  896: { name: "Max Lightning", type: "ELECTRIC" },
  897: { name: "Max Mindstorm", type: "PSYCHIC" },
  898: { name: "Max Hailstorm", type: "ICE" },
  899: { name: "Max Wyrmwind", type: "DRAGON" },
  900: { name: "Max Darkness", type: "DARK" },
  901: { name: "Max Starfall", type: "FAIRY" },
  902: { name: "G-Max Vine Lash", type: "GRASS" },
  903: { name: "G-Max Wildfire", type: "FIRE" },
  904: { name: "G-Max Cannonade", type: "WATER" },
  905: { name: "G-Max Befuddle", type: "BUG" },
  906: { name: "G-Max Volt Crash", type: "ELECTRIC" },
  907: { name: "G-Max Gold Rush", type: "NORMAL" },
  908: { name: "G-Max Chi Strike", type: "FIGHTING" },
  909: { name: "G-Max Terror", type: "GHOST" },
  910: { name: "G-Max Foam Burst", type: "WATER" },
  911: { name: "G-Max Resonance", type: "ICE" },
  912: { name: "G-Max Cuddle", type: "NORMAL" },
  913: { name: "G-Max Replenish", type: "NORMAL" },
  914: { name: "G-Max Malodor", type: "POISON" },
  915: { name: "G-Max Meltdown", type: "STEEL" },
  916: { name: "G-Max Drum Solo", type: "GRASS" },
  917: { name: "G-Max Fireball", type: "FIRE" },
  918: { name: "G-Max Hydrosnipe", type: "WATER" },
  919: { name: "G-Max Wind Rage", type: "FLYING" },
  920: { name: "G-Max Gravitas", type: "PSYCHIC" },
  921: { name: "G-Max Stonesurge", type: "WATER" },
  922: { name: "G-Max Volcalith", type: "ROCK" },
  923: { name: "G-Max Tartness", type: "GRASS" },
  924: { name: "G-Max Sweetness", type: "GRASS" },
  925: { name: "G-Max Sandblast", type: "GROUND" },
  926: { name: "G-Max Stun Shock", type: "ELECTRIC" },
  927: { name: "G-Max Centiferno", type: "FIRE" },
  928: { name: "G-Max Smite", type: "FAIRY" },
  929: { name: "G-Max Snooze", type: "DARK" },
  930: { name: "G-Max Finale", type: "FAIRY" },
  931: { name: "G-Max Steelsurge", type: "STEEL" },
  932: { name: "G-Max Depletion", type: "DRAGON" },
  933: { name: "G-Max One Blow", type: "DARK" },
  934: { name: "G-Max Rapid Flow", type: "WATER" },
};
export const MOVE_TYPE_COLORS: Record<string, string> = {
  NORMAL: '#A8A878',
  FIGHTING: '#C03028',
  FLYING: '#A890F0',
  POISON: '#A040A0',
  GROUND: '#E0C068',
  ROCK: '#B8A038',
  BUG: '#A8B820',
  GHOST: '#705898',
  STEEL: '#B8B8D0',
  FIRE: '#F08030',
  WATER: '#6890F0',
  GRASS: '#78C850',
  ELECTRIC: '#F8D030',
  PSYCHIC: '#F85888',
  ICE: '#98D8D8',
  DRAGON: '#7038F0',
  DARK: '#705848',
  FAIRY: '#EE99AC',
};

